import { ITermItem, TActiveCondition, useTermCheck } from './useTermCheck';
import useModal from './useModal';

export const useTermBottomsheet = (
  termList: ITermItem[],
  activeCondition: TActiveCondition,
) => {
  const modal = useModal(false);
  const termCheck = useTermCheck(termList, activeCondition);

  const open = () => {
    termCheck.checkList.forEach((item, idx) => {
      item.isExpand = false;
    });
    modal.open();
  }

  return {
    ...termCheck,
    ...modal,
    open,
    checkList: termCheck.checkList.map((item, idx) => ({
      key: item.text + idx,
      isExpand: item.isExpand,
      checked: item.checked,
      text: item.text,
      icon: true,
      termCd: item.termCd,
      subTextItem: item.subTextItem,
    })),
  };
};
